import { Row } from "@tanstack/react-table";
import { Schedule2 } from "../../../../../../../services/cloudchipr.api";
import { frequencySortingFn } from "../../../../common/utils/sortingFunctions/frequencySortingFn";

export const scheduledJobsFrequencySortingFn = (
  currentRow: Row<Schedule2>,
  nextRow: Row<Schedule2>,
) => {
  const current = currentRow.original.cron;
  const next = nextRow.original.cron;

  return frequencySortingFn(current, next);
};
